import {
  Box,
  makeStyles,
  InputLabel,
  TextField,
  FormControl,
  Select,
  Button,
  Typography,
} from "@material-ui/core";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Fragment } from "react";
import { Helmet } from "react-helmet";
import { backend } from "../../../api";
import { PageBanner } from "../../../components";
import { DropzoneArea } from "material-ui-dropzone";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { authorAddAdverBook } from "../../../redux-store/books/actions";
import { ADD_BOOK_RESET } from "../../../redux-store/constants";

const useStyles = makeStyles((theme) => ({
  fieldLabel: {
    color: theme.palette.secondary.light,
    marginBottom: "8px",
    fontSize: "15px",
    fontWeight: 500,
  },
  inputField: {
    padding: "10px",
    borderRadius: "2px",
  },
  submitBtn: {
    color: theme.palette.secondary.light,
    backgroundColor: theme.palette.primary.main,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
    },
  },
  cancelBtn: {
    backgroundColor: theme.palette.secondary.dark,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    color: theme.palette.secondary.light,
  },
  addBtn: {
    backgroundColor: theme.palette.primary.dark,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    color: theme.palette.secondary.light,
  },
}));

const LoanBooks = () => {
  const classes = useStyles();
  const [title, setTitle] = useState("");
  const [cover, setCover] = useState("");
  const [story, setStory] = useState("");
  const [category, setCategory] = useState({ category_name: "Biography" });
  const [pdfFile, setPdfFile] = useState("");
  const [categories, setCategories] = useState([]);
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.auth);
  const { success } = useSelector((state) => state.addBook);
  const history = useHistory();

  useEffect(() => {
    fetchCategory();
    if (success) {
      dispatch({ type: ADD_BOOK_RESET });
      history.replace(`/dashboard/${currentUser?.author?.role}`);
    }
  }, [success]);

  const fetchCategory = () => {
    backend
      .get("/category")
      .then((res) => {
        if (res.data.message === "Book Category Found Successfully") {
          setCategories(res.data.data);
          setCategory(res.data.data[0]._id);
        }
      })
      .catch((err) => {
        let message = err.response ? err.response.data.message : err.message;
        toast.error(message);
      });
  };
  const handleFormSubmit = (e) => {
    e.preventDefault();
    let newBook;
    newBook = {
      book_title: title,
      book_category: category,
      book_story: story,
      book_cover: cover,
      author: currentUser.author._id,
      writer: currentUser._id,
      pdf_file: pdfFile,
    };
    dispatch(authorAddAdverBook(newBook));
  };

  const handleChangeCategory = (e) => {
    setCategory(e.target.value);
  };

  const uploadFileToS3 = (val, file) => {
    backend
      .post("/file/fileUpload", file)
      .then((res) => {
        if (res.status === 200) {
          if (val === "cover") {
            setCover(res.data.locationArray[0].fileLocation);
          } else if (val === "pdfBook") {
            setPdfFile(res.data.locationArray[0].fileLocation);
          }
        }
      })
      .catch(() => {
        // toast.error("Error in File Upload. Does not support this format.");
      });
  };

  return (
    <Fragment>
      <Helmet>
        <title>Loan Book</title>
      </Helmet>
      <ToastContainer />
      <PageBanner
        image={"/assets/images/bg4.jpg"}
        title={"Add KleverBook"}
        size="small"
        titleAlign="left"
      />
      <Box style={{ width: "80%", maxWidth: 600, margin: "50px auto" }}>
        <Typography variant="body2" color="error" style={{ marginBottom: 20 }}>
          * All Fields are Necessary
        </Typography>

        {categories && (
          <form onSubmit={handleFormSubmit}>
            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>Title</InputLabel>
              <FormControl fullWidth>
                <TextField
                  variant="outlined"
                  type="text"
                  required
                  className={classes.inputField}
                  name="title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </FormControl>
            </Box>
            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>Cover</InputLabel>
              <DropzoneArea
                onChange={(files) => {
                  let formData = new FormData();
                  formData.append("files", files[0]);
                  uploadFileToS3("cover", formData);
                }}
                acceptedFiles={["image/*"]}
                maxFileSize={3000000}
                filesLimit={1}
                onDelete={() => setCover("")}
                name="img"
                id="cvr"
                inputProps={{
                  name: "img",
                  id: "cvr",
                  required: true,
                  style: { display: "inline-block", opacity: 0 },
                }}
                dropzoneText="Upload Image for Book Cover"
                style={{ maxHeight: 100 }}
              />
            </Box>
            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>Category</InputLabel>
              <FormControl variant="outlined" fullWidth>
                <Select
                  native
                  onChange={handleChangeCategory}
                  placeholder="Select Category"
                >
                  {categories.map((item) => (
                    <option value={item._id}>{item.category_name}</option>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>
                BOOK PDF File
              </InputLabel>
              <DropzoneArea
                onChange={(files) => {
                  let formData = new FormData();
                  formData.append("files", files[0]);
                  uploadFileToS3("pdfBook", formData);
                }}
                acceptedFiles={["application/pdf"]}
                filesLimit={1}
                name="book"
                id="bookfile"
                inputProps={{
                  name: "book",
                  id: "bookfile",
                  required: true,
                  style: { display: "inline-block", opacity: 0 },
                }}
                onDelete={() => setPdfFile("")}
                dropzoneText="Upload PDF File of Book"
                style={{ maxHeight: 100 }}
              />
            </Box>
            <Box mb={2}>
              <InputLabel className={classes.fieldLabel}>Story</InputLabel>
              <FormControl fullWidth>
                <TextField
                  variant="outlined"
                  type="text"
                  required
                  className={classes.inputField}
                  multiline
                  rows={8}
                  name="story"
                  value={story}
                  onChange={(e) => setStory(e.target.value)}
                />
              </FormControl>
            </Box>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Button
                className={classes.cancelBtn}
                onClick={() => history.goBack()}
              >
                Go Back
              </Button>
              <Button type="submit" className={classes.submitBtn}>
                Upload
              </Button>
            </Box>
          </form>
        )}
      </Box>
    </Fragment>
  );
};

export default LoanBooks;
